import React from "react";

export default function FooterLower() {
  return (
    <div className="footer-lower-wrapper">
      <div className="footer-lower">
        <div className="footer-lower-div">
          <div>
            <h3>Amzin Music</h3>
            <p>Stream millions of songs</p>
          </div>
          <div>
            <h3>Amzin Advertising</h3>
            <p>Find, attract, and engage customers</p>
          </div>
          <div>
            <h3>Amzin Drive</h3>
            <p>Cloud storage from Amzin</p>
          </div>
          <div>
            <h3>6pm</h3>
            <p>Score deals on fashion brands</p>
          </div>
          <div>
            <h3>AbeBooks</h3>
            <p>Books, art & collectibles</p>
          </div>
          <div>
            <h3>ACX</h3>
            <p>Audiobook Publishing Made Easy</p>
          </div>
          <div>
            <h3>Sell on Amzin</h3>
            <p>Start a Selling Account</p>
          </div>
          <div>
            <h3>Amzin Business</h3>
            <p>Everything For Your Business</p>
          </div>
          <div>
            <h3>Amzin Fresh</h3>
            <p>Groceries & More Right To Your Door</p>
          </div>
          <div>
            <h3>AmzinGlobal</h3>
            <p>Ship Orders Internationally</p>
          </div>
          <div>
            <h3>Home Services</h3>
            <p>Experienced Pros Happiness Guarantee</p>
          </div>
          <div>
            <h3>Amzin Ignite</h3>
            <p>Sell your original Digital Educational Resources</p>
          </div>
          <div>
            <h3>Amzin Web Services</h3>
            <p>Scalable Cloud Computing Services</p>
          </div>
          <div>
            <h3>Audible</h3>
            <p>Listen to Books & Original Audio Performances</p>
          </div>
          <div>
            <h3>Book Depository</h3>
            <p>Books With Free Delivery Worldwide</p>
          </div>
          <div>
            <h3>Box Office Mojo</h3>
            <p>Find Movie Box Office Data</p>
          </div>
          <div>
            <h3>ComiXology</h3>
            <p>Thousands of Digital Comics</p>
          </div>
          <div>
            <h3>DPReview</h3>
            <p>Digital Photography</p>
          </div>
          <div>
            <h3>Fabric</h3>
            <p>Sewing, Quilting & Knitting</p>
          </div>
          <div>
            <h3>Goodreads</h3>
            <p>Book reviews & recommendations</p>
          </div>
          <div>
            <h3>IMDb</h3>
            <p>Movies, TV & Celebrities</p>
          </div>
          <div>
            <h3>IMDbPro</h3>
            <p>Get Info Entertainment Professionals Need</p>
          </div>
          <div>
            <h3>Kindle Direct Publishing</h3>
            <p>Indie Digital & Print Publishing Made Easy</p>
          </div>
          <div>
            <h3>Amzin Photos</h3>
            <p>Unlimited Photo Storage Free With Prime</p>
          </div>
          <div>
            <h3>Prime Video Direct</h3>
            <p>Video Distribution Made Easy</p>
          </div>
          <div>
            <h3>Shopbop</h3>
            <p>Designer Fashion Brands</p>
          </div>
          <div>
            <h3>Amzin Warehouse</h3>
            <p>Great Deals on Quality Used Products</p>
          </div>
          <div>
            <h3>Whole Foods Market</h3>
            <p>America’s Healthiest Grocery Store</p>
          </div>
          <div>
            <h3>Woot!</h3>
            <p>Deals and Shenanigans</p>
          </div>
          <div>
            <h3>Zappos</h3>
            <p>Shoes & Clothing</p>
          </div>
          <div>
            <h3>Ring</h3>
            <p>Smart Home Security Systems</p>
          </div>
          <div>
            <h3>eero WiFi</h3>
            <p>Stream 4K Video in Every Room</p>
          </div>
          <div>
            <h3>Blink</h3>
            <p>Smart Security for Every Home</p>
          </div>
          <div>
            <h3>Neighbors App</h3>
            <p>Real-Time Crime & Safety Alerts</p>
          </div>
          <div>
            <h3>Amzin Subscription Boxes</h3>
            <p>Top subscription boxes – right to your door</p>
          </div>
          <div className="footer-lower-last-content1">
            <h3>PillPack</h3>
            <p>Pharmacy Simplified</p>
          </div>
          <div className="footer-lower-last-content2">
            <h3>Amzin Renewed</h3>
            <p>Like-new products you can trust</p>
          </div>
        </div>
        <div className="footer-lower-bottom">
          <a href="/">Conditions of Use</a>
          <a href="/">Privacy Notice</a>
          <a href="/">Your Ads Privacy Choices</a>
        </div>
        <p className="footer-lower-bottom-p">
          This website is an artistic recreation of Amazon.com and is only for
          personal use.
        </p>
      </div>
    </div>
  );
}
